<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { FluidityModule } from '@ibgroup-tws-webapps/fluidity';
import { locale } from '@ibgroup-tws-webapps/ratio.ui';
import Skeleton from 'primevue/skeleton';

const props = defineProps<{ conid: number }>();
const { t } = useI18n();

const langDir = computed(() => (locale?.isRtl()?.value ? 'rtl' : 'ltr'));

const newsModuleProps = computed(() => ({
  noContract: true,
  config: [{ feed: `contract:${props.conid}`, pageSize: 10, showMore: true, label: 'product' }],
}));
</script>

<template>
  <div :dir="langDir" class="w-full relative overflow-hidden">
    <h5 class="text-lg font-medium text-on-surface">{{ t('news') }}</h5>
    <FluidityModule moduleName="news4" :module-props="newsModuleProps">
      <template #loading>
        <div class="flex flex-col gap-3">
          <div v-for="i in 5" :key="i" class="flex items-center gap-4 justify-between border-b pb-3">
            <div class="w-full">
              <Skeleton animation="none" width="100px" height=".875rem" class="mb-1" />
              <Skeleton animation="none" width="80%" height="2.5rem" />
              <div class="flex items-center gap-1 mt-1">
                <Skeleton animation="none" width="100px" height=".875rem" />
                <Skeleton animation="none" width="80px" height=".875rem" />
              </div>
            </div>
            <Skeleton animation="none" width="64px" height="64px" class="flex-shrink-0" />
          </div>
        </div>
      </template>
    </FluidityModule>
  </div>
</template>
